import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { Field, reduxForm, formValueSelector, change } from 'redux-form'
import { SelectField } from 'redux-form-material-ui'
import MenuItem from 'material-ui/MenuItem'
import { getWorldsWithCategories } from '../../selectors'
import { themeColors } from '../../styles/theme'

class SelectCategoryForm extends PureComponent {
  render() {
    const { worlds, categories, currentCategory } = this.props

    return (
      <form>
        <Field
          name="world"
          onChange={() => this.props.change('add-item-form', 'category', null)}
          component={SelectField}
          fullWidth={true}
          floatingLabelText="Seleziona un mondo">
          {worlds.map(w => (
            <MenuItem key={w.id} value={w} primaryText={w.nome} />
          ))}
        </Field>

        <Field
          name="category"
          component={SelectField}
          fullWidth={true}
          floatingLabelText="Seleziona una categoria">
          {categories.map(c => (
            <MenuItem key={c.id} value={c} primaryText={c.nome} />
          ))}
        </Field>
        {currentCategory &&
          currentCategory.slug === 'musica' &&
          <div style={{ color: themeColors.positive }}>
            Vuoi aggiungere un Disco in Vinile?
            La categoria corretta è
            {' '}
            <b>Vinile</b> nel mondo
            {' '}
            <b>Collezionismo</b>
          </div>}
        {currentCategory &&
          currentCategory.slug === 'libri' &&
          <div style={{ color: themeColors.positive }}>
            Vuoi aggiungere un fumetto?
            Seleziona il mondo
            {' '}
            <b>Collezionismo</b> e la categoria
            {' '}
            <b>Fumetti da collezione</b>
          </div>}
      </form>
    )
  }
}

const selector = formValueSelector('add-item-form')
const emptyList = []

const mapStateToProps = state => {
  const currentWorld = selector(state, 'world')
  const currentCategory = selector(state, 'category')

  return {
    currentCategory,
    worlds: getWorldsWithCategories(state),
    categories: currentWorld ? currentWorld.categories : emptyList,
  }
}

export default reduxForm({
  form: 'add-item-form',
})(
  connect(mapStateToProps, {
    change,
  })(SelectCategoryForm)
)



// WEBPACK FOOTER //
// ./src/common/AddItemForm/SelectCategoryForm.js